interface Props {
  lastUpdated: string
}

export function PageTitle({ lastUpdated }: Props) {
  return (
    <div className="page-title">
      <div>
        <span className="eyebrow">Automation Control Tracking</span>
        <h1>Controllo dispositivi</h1>
      </div>
      <div className="meta-inline">
        Polling: dispositivi <strong>30s</strong> · sensori <strong>15min</strong> · Ultimo aggiornamento <strong>{lastUpdated}</strong>
      </div>
    </div>
  )
}
